module.exports = __webpack_public_path__ + "img/386.cf44fe88.png";